// services/pdfService.js
import jsPDF from 'jspdf';

const pdfService = {
  generatePurchaseOrderPDF: (purchaseOrder) => {
    const doc = new jsPDF();
    
    // Set initial y position
    let yPosition = 20;
    
    // Company Header
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('FAIREIRST INSURANCE LIMITEDsssssssssssssssssssss', 105, yPosition, { align: 'center' });
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text('(Company No.PB 5180)', 105, yPosition + 7, { align: 'center' });
    doc.text('No.33, St. Michael\'s Road, Colombo 03, Sri Lanka.', 105, yPosition + 12, { align: 'center' });
    doc.text('Tel:011-2428428 (Customer Service) 011-242800(General Line) Fax:011-2438438', 105, yPosition + 17, { align: 'center' });
    doc.text('E-mail: info@fairfirst.lk Website: www.fairfirst.lk', 105, yPosition + 22, { align: 'center' });
    
    yPosition += 35;
    
    // Purchase Order Title
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('PURCHASE ORDER', 105, yPosition, { align: 'center' });
    
    yPosition += 15;
    
    // Supplier Information
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('To', 20, yPosition);
    doc.text('Date', 20, yPosition + 5);
    doc.text('PO Number', 20, yPosition + 10);
    
    doc.setFont('helvetica', 'normal');
    doc.text(`${purchaseOrder.supplier?.name || 'N/A'}`, 40, yPosition);
    doc.text(`${purchaseOrder.supplier?.address || 'N/A'}`, 40, yPosition + 5);
    
    doc.text(new Date(purchaseOrder.order_date).toLocaleDateString(), 40, yPosition + 10);
    doc.text(purchaseOrder.po_number, 40, yPosition + 15);
    
    doc.setFont('helvetica', 'bold');
    doc.text('Re', 120, yPosition);
    doc.text('Version', 120, yPosition + 5);
    
    doc.setFont('helvetica', 'normal');
    doc.text('Purchase Order', 140, yPosition);
    doc.text('1', 140, yPosition + 5);
    
    yPosition += 25;
    
    // Table Headers
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    
    // Draw table headers
    doc.text('Description', 20, yPosition);
    doc.text('Quantity', 120, yPosition);
    doc.text('Unit Rate (Rs.)', 140, yPosition);
    doc.text('Amount (Rs.)', 170, yPosition);
    
    // Draw header line
    doc.line(20, yPosition + 2, 190, yPosition + 2);
    
    yPosition += 10;
    
    // Table Data
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    
    let subtotal = 0;
    
    // Items
    purchaseOrder.items.forEach(item => {
      const description = item.product?.name || 'N/A';
      const quantity = item.quantity.toString();
      const unitPrice = parseFloat(item.unit_price).toFixed(2);
      const amount = (item.quantity * item.unit_price).toFixed(2);
      
      subtotal += item.quantity * item.unit_price;
      
      // Split long descriptions into multiple lines
      const descriptionLines = doc.splitTextToSize(description, 80);
      
      if (descriptionLines.length > 1) {
        doc.text(descriptionLines[0], 20, yPosition);
        doc.text(quantity, 120, yPosition);
        doc.text(unitPrice, 140, yPosition);
        doc.text(amount, 170, yPosition);
        
        yPosition += 6;
        
        for (let i = 1; i < descriptionLines.length; i++) {
          doc.text(descriptionLines[i], 20, yPosition);
          yPosition += 6;
        }
      } else {
        doc.text(description, 20, yPosition);
        doc.text(quantity, 120, yPosition);
        doc.text(unitPrice, 140, yPosition);
        doc.text(amount, 170, yPosition);
        yPosition += 6;
      }
      
      // Check if we need a new page
      if (yPosition > 250) {
        doc.addPage();
        yPosition = 20;
        
        // Redraw headers on new page
        doc.setFont('helvetica', 'bold');
        doc.text('Description', 20, yPosition);
        doc.text('Quantity', 120, yPosition);
        doc.text('Unit Rate (Rs.)', 140, yPosition);
        doc.text('Amount (Rs.)', 170, yPosition);
        doc.line(20, yPosition + 2, 190, yPosition + 2);
        yPosition += 10;
        doc.setFont('helvetica', 'normal');
      }
    });
    
    // Totals
    yPosition += 5;
    doc.line(20, yPosition, 190, yPosition);
    yPosition += 8;
    
    const discount = 0;
    const nbt = 0;
    const vat = 0;
    const btt = 0;
    const total = subtotal;
    
    doc.text('Total amount', 120, yPosition);
    doc.text(subtotal.toFixed(2), 170, yPosition);
    yPosition += 6;
    
    doc.text('Discount', 120, yPosition);
    doc.text(discount.toFixed(2), 170, yPosition);
    yPosition += 6;
    
    doc.text('NBT 2 %', 120, yPosition);
    doc.text(nbt.toFixed(2), 170, yPosition);
    yPosition += 6;
    
    doc.text('V.A.T 15 %', 120, yPosition);
    doc.text(vat.toFixed(2), 170, yPosition);
    yPosition += 6;
    
    doc.text('B.T.T 1 %', 120, yPosition);
    doc.text(btt.toFixed(2), 170, yPosition);
    yPosition += 6;
    
    doc.setFont('helvetica', 'bold');
    doc.text('Total', 120, yPosition);
    doc.text(total.toFixed(2), 170, yPosition);
    
    // Footer
    const pageHeight = doc.internal.pageSize.height;
    yPosition = pageHeight - 40;
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('Other Details', 20, yPosition);
    
    doc.setFont('helvetica', 'normal');
    doc.text('Please deliver to', 20, yPosition + 10);
    doc.text('Samith Wijesuriya', 20, yPosition + 15);
    doc.text('(AUTHORISED SIGNATORY)', 20, yPosition + 20);
    
    // Save the PDF
    doc.save(`Purchase-Order-${purchaseOrder.po_number}.pdf`);
  }
};

export default pdfService;